import { render, staticRenderFns } from "./cadastroProduto.vue?vue&type=template&id=0f09d5ac"
import script from "./cadastroProduto.vue?vue&type=script&lang=js"
export * from "./cadastroProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports